var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "cd-container" },
    [
      _c(
        "b-row",
        _vm._l(_vm.extendedTrimLevels, function(trimLevel) {
          return _c(
            "b-col",
            {
              key: trimLevel.id,
              staticClass: "cd-entry cd-trim-level p-2",
              attrs: { cols: "12", sm: "6", md: "6", lg: "3", xl: "3" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.selectTrimLevel(trimLevel)
                }
              }
            },
            [
              _c("Box", { staticClass: "cd-primary-sub-color" }, [
                _c("span", { staticClass: "cd-trimlevel-label" }, [
                  _vm._v(_vm._s(trimLevel.label))
                ]),
                _c(
                  "ul",
                  { staticClass: "cd-trim-level-list" },
                  _vm._l(trimLevel.equipmentHighlights, function(highlight) {
                    return _c("li", { key: highlight }, [
                      _vm._v(" " + _vm._s(highlight) + " ")
                    ])
                  }),
                  0
                ),
                _c("p", { staticClass: "more-link-container" }, [
                  _c(
                    "a",
                    {
                      staticClass: "more-link",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.showEquipment(trimLevel)
                        }
                      }
                    },
                    [_vm._v("mehr erfahren")]
                  )
                ]),
                _c("div", { staticClass: "cd-trim-level-price" }, [
                  _c("span", { staticClass: "cd-original-price" }, [
                    _vm._v(
                      "uvp ab " +
                        _vm._s(
                          _vm._f("formatCurrency")(trimLevel.min_price_gross)
                        ) +
                        " €"
                    )
                  ]),
                  _c("span", { staticClass: "cd-new-price" }, [
                    _vm._v(
                      "ab " +
                        _vm._s(
                          _vm._f("formatCurrency")(
                            _vm.getNewPrice(
                              trimLevel["min_price_" + _vm.pricing],
                              trimLevel
                            )
                          )
                        ) +
                        " €"
                    )
                  ])
                ]),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-hover",
                    attrs: { type: "button" }
                  },
                  [_vm._v("jetzt konfigurieren")]
                )
              ])
            ],
            1
          )
        }),
        1
      ),
      _c("b-modal", {
        attrs: {
          static: "",
          scrollable: "",
          id: "cd-modal-equipment-compairsion",
          title: "Ausstattungsvergleich",
          size: "xl"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              return [
                _c(
                  "b-container",
                  { staticClass: "cd-equipment-summary-header" },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c(
                            "p",
                            { staticClass: "cd-equipment-summary-first" },
                            [_vm._v(" " + _vm._s(_vm.currentMaker.label))]
                          ),
                          _c(
                            "p",
                            { staticClass: "cd-equipment-summary-second" },
                            [_vm._v(" " + _vm._s(_vm.currentModel.label))]
                          ),
                          _c(
                            "p",
                            { staticClass: "cd-equipment-summary-second" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.currentBodyDesign.label) + " "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "b-container",
                  [
                    _c(
                      "b-row",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "p",
                              { staticClass: "cd-compairsion-selection-hint" },
                              [
                                _vm._v(
                                  " Bitte wählen Sie 2 verschiedene Ausstattungslinien. "
                                )
                              ]
                            ),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  id: "difference-only",
                                  name: "difference-only"
                                },
                                model: {
                                  value: _vm.showDifference,
                                  callback: function($$v) {
                                    _vm.showDifference = $$v
                                  },
                                  expression: "showDifference"
                                }
                              },
                              [_vm._v("nur Unterschiede anzeigen")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { xs: "12", md: "6" } },
                          [
                            _c("v-select", {
                              attrs: {
                                label: "label",
                                placeholder: "Modell 1",
                                options: _vm.extendedTrimLevels
                              },
                              model: {
                                value: _vm.firstSelectedTrimLevel,
                                callback: function($$v) {
                                  _vm.firstSelectedTrimLevel = $$v
                                },
                                expression: "firstSelectedTrimLevel"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          [
                            _c("v-select", {
                              attrs: {
                                label: "label",
                                placeholder: "Modell 2",
                                options: _vm.extendedTrimLevels
                              },
                              model: {
                                value: _vm.secondSelectedTrimLevel,
                                callback: function($$v) {
                                  _vm.secondSelectedTrimLevel = $$v
                                },
                                expression: "secondSelectedTrimLevel"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("b-container", { staticClass: "pt-4 p-0" }, [
                  _c(
                    "div",
                    { staticClass: "cd-accordion", attrs: { role: "tablist" } },
                    _vm._l(_vm.equipmentCompairsion, function(
                      category,
                      categoryIndex
                    ) {
                      return _c(
                        "b-card",
                        {
                          key: category.category,
                          staticStyle: { padding: "0" },
                          attrs: { "no-body": "" }
                        },
                        [
                          _c(
                            "b-card-header",
                            {
                              staticClass: "p-0",
                              attrs: { "header-tag": "header", role: "tab" }
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle",
                                      value:
                                        "equipment-category-" + categoryIndex,
                                      expression:
                                        "'equipment-category-' + categoryIndex"
                                    }
                                  ],
                                  staticClass: "cd-accordion-header-button",
                                  attrs: { block: "" }
                                },
                                [_vm._v(_vm._s(category.category))]
                              )
                            ],
                            1
                          ),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "equipment-category-" + categoryIndex,
                                visible: "",
                                accordion: "my-accordion",
                                role: "tabpanel"
                              }
                            },
                            [
                              _c(
                                "b-card-body",
                                { staticClass: "p-0" },
                                [
                                  _c(
                                    "b-container",
                                    _vm._l(category.equipmentList, function(
                                      equipment,
                                      equipmentIndex
                                    ) {
                                      return _c(
                                        "b-row",
                                        {
                                          key: equipmentIndex,
                                          staticClass: "cd-equipment-row"
                                        },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "6" } },
                                            [_vm._v(_vm._s(equipment.title))]
                                          ),
                                          _c(
                                            "b-col",
                                            { staticClass: "cd-center" },
                                            [
                                              equipment.cars[0]
                                                ? _c("i", {
                                                    staticClass: "check-icon"
                                                  })
                                                : _vm._e()
                                            ]
                                          ),
                                          _c(
                                            "b-col",
                                            { staticClass: "cd-center" },
                                            [
                                              equipment.cars[1]
                                                ? _c("i", {
                                                    staticClass: "check-icon"
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "modal-footer",
            fn: function(ref) {
              var ok = ref.ok
              return [
                _c(
                  "b-button",
                  {
                    staticClass: "cd-button",
                    attrs: { size: "sm" },
                    on: {
                      click: function($event) {
                        return ok()
                      }
                    }
                  },
                  [_vm._v("Schliessen")]
                )
              ]
            }
          }
        ])
      }),
      _c("b-modal", {
        attrs: {
          static: "",
          scrollable: "",
          id: "cd-equipment-modal",
          size: "lg",
          title: _vm.equipmentTitle
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              return [
                _c(
                  "b-container",
                  { staticClass: "cd-equipment-summary-header" },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c(
                            "p",
                            { staticClass: "cd-equipment-summary-first" },
                            [_vm._v(" " + _vm._s(_vm.currentMaker.label))]
                          ),
                          _c(
                            "p",
                            { staticClass: "cd-equipment-summary-second" },
                            [_vm._v(" " + _vm._s(_vm.currentModel.label))]
                          ),
                          _c(
                            "p",
                            { staticClass: "cd-equipment-summary-second" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.currentBodyDesign.label) + " "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "cd-accordion", attrs: { role: "tablist" } },
                  _vm._l(_vm.selectedTrimLevel.equipmentList, function(
                    equipmentCategory,
                    categoryIndex
                  ) {
                    return _c(
                      "b-card",
                      {
                        key: equipmentCategory.category,
                        staticClass: "mb-1",
                        attrs: { "no-body": "" }
                      },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-1",
                            attrs: { "header-tag": "header", role: "tab" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value:
                                      "equipment-category-" + categoryIndex,
                                    expression:
                                      "'equipment-category-' + categoryIndex"
                                  }
                                ],
                                staticClass: "cd-accordion-header-button",
                                attrs: { block: "" }
                              },
                              [_vm._v(_vm._s(equipmentCategory.category))]
                            )
                          ],
                          1
                        ),
                        _c(
                          "b-collapse",
                          {
                            attrs: {
                              id: "equipment-category-" + categoryIndex,
                              visible: "",
                              accordion: "my-accordion",
                              role: "tabpanel"
                            }
                          },
                          [
                            _c("b-card-body", [
                              _c(
                                "ul",
                                { staticClass: "cd-equipment-list" },
                                _vm._l(
                                  equipmentCategory.equipmentEntries,
                                  function(equipmentLabel, equipmentIndex) {
                                    return _c("li", { key: equipmentIndex }, [
                                      _vm._v(" " + _vm._s(equipmentLabel) + " ")
                                    ])
                                  }
                                ),
                                0
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ]
            }
          },
          {
            key: "modal-footer",
            fn: function(ref) {
              var ok = ref.ok
              return [
                _c(
                  "b-button",
                  {
                    staticClass: "cd-button",
                    attrs: { size: "sm" },
                    on: {
                      click: function($event) {
                        return ok()
                      }
                    }
                  },
                  [_vm._v("Schliessen")]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }